import { useMutation } from 'react-query';
import { authFetch } from '../../../../../../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../../../../../../CommonUtils/httpBodyOptions';

interface Params {
  accountId: string;
  toConsumerId: number;
}

const moveAccount = (params: Params) => {
  return authFetch('/Adviser/Adviser/MoveAccount', {
    method: 'POST',
    ...httpBodyOptions(params),
  });
};

export const useMoveAccountMutation = () => {
  return useMutation(moveAccount);
};
